import Accordion from "./Accordion";
import Card from "../UI/Card";

import styles from "./Questions.module.css";
const Questions = (props) => {
  const { questions } = props;

  return (
    <Card
      className={styles["questions-container"]}
    >
      {questions.map((question) => {
        return (
          <Accordion
            key={question.id}
            {...question}
          />
        );
      })}
    </Card>
  );
};

export default Questions;
